import z from "zod";

const environmentErrorTypeValues = ["NON_PUBLIC_ENV_ACCESS_ON_CLIENT", "INVALID_ENV_VARIABLE"] as const;

const environmentErrorTypeSchema = z.enum(environmentErrorTypeValues);
const EnvironmentErrorType = environmentErrorTypeSchema.enum;
type EnvironmentErrorType = z.infer<typeof environmentErrorTypeSchema>;

type ErrorDetails = {
  sentryDescription: string;
};

export type EnvironmentErrors =
  | {
      errorType: typeof EnvironmentErrorType.NON_PUBLIC_ENV_ACCESS_ON_CLIENT;
      data: {
        variableName: string;
      };
    }
  | {
      errorType: typeof EnvironmentErrorType.INVALID_ENV_VARIABLE;
      data: {
        variableName: string;
        errorMessage: string;
      };
    };

export const environmentErrorDetails: Record<EnvironmentErrorType, ErrorDetails> = {
  [EnvironmentErrorType.NON_PUBLIC_ENV_ACCESS_ON_CLIENT]: {
    sentryDescription: "Attempted to access non-public environment variable on the client",
  },
  [EnvironmentErrorType.INVALID_ENV_VARIABLE]: {
    sentryDescription: "Invalid environment variable",
  },
};
